import { type FC, useMemo } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./tabs";
import { type ExtractedResult, type PdfViewerFile, ViewPdfWebViewer } from "./view-pdf-webviewer";

export interface FileViewerProps {
  extractedResults: ExtractedResult[];
  files?: PdfViewerFile[];
  headers: HeadersInit;
  selectedFile?: PdfViewerFile;
  setSelectedFile: (file: PdfViewerFile | undefined) => void;
}

export const FileViewer: FC<FileViewerProps> = ({
  extractedResults,
  files,
  headers,
  selectedFile,
  setSelectedFile,
}) => {
  const defaultSelectedFile = useMemo(() => selectedFile ?? files?.[0] ?? undefined, [selectedFile, files]);

  if (!files) {
    return null;
  }

  return (
    <Tabs
      value={defaultSelectedFile?.id}
      onValueChange={(value) => setSelectedFile(files.find((file) => file.id === value))}
    >
      <TabsList className="mb-4">
        {files.map((file) => (
          <TabsTrigger key={file.id} value={file.id}>
            {file.filename}
          </TabsTrigger>
        ))}
      </TabsList>

      {files.map((file) => (
        <TabsContent key={file.id} value={file.id}>
          <ViewPdfWebViewer headers={headers} file={file} extractedResults={extractedResults} />
        </TabsContent>
      ))}
    </Tabs>
  );
};
